import * as s from "../../LoginStyled";
import * as cs from "../../../SignCommonStyled";
import { LOGIN_STEP, LoginInfo } from "../../LoginContainer";
import BigButton from "components/atoms/buttons/BigButton";

interface Props {
  loginInfo: LoginInfo;
  onClickSentEmail: () => void;
  onChangeStep: (step: LOGIN_STEP) => void;
}

export default function ForgotEmailSent({
  loginInfo,
  onClickSentEmail,
  onChangeStep,
}: Props) {
  return (
    <>
      <s.InputWrapper>
        <s.LoginInfo>
          <h3>EMAIL REMINDER SENT</h3>
          <p className="description">
            We've sent a text message to&nbsp;
            <strong>{loginInfo.tel}</strong>&nbsp;with your myDW email. Click
            "resend" if you did not receive it.
          </p>
        </s.LoginInfo>
        <cs.MarginBottom>
          <BigButton
            label="Resend Message"
            buttonType="cancel"
            onClickBtn={onClickSentEmail}
            data-testid="auth-signin-email-button-click-sent-email"
          />
          <BigButton
            label="Back to login screen"
            onClickBtn={() => onChangeStep(LOGIN_STEP.INPUT_EMAIL)}
            data-testid="auth-signin-email-button-change-step"
          />
        </cs.MarginBottom>
      </s.InputWrapper>
    </>
  );
}
